import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import './Login.css';
import logo from '../assets/images/light/Logo.png';
import Footer from './Footer';

const SUPABASE_EDGE_URL = "https://fztfytovnyxxetzgjzxl.supabase.co/functions/v1/authentication/google-auth";

function Login() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    localStorage.removeItem('is_admin');
    localStorage.setItem('is_admin', 'false');

    const storedToken = localStorage.getItem('auth_token');
    if (storedToken) {
      setToken(storedToken);
      const payload = parseJwt(storedToken);
      setUser({
        email: payload.email,
        name: payload.name,
        picture: payload.picture,
      });
      navigate('/home');
    }
  }, [navigate]);

  const parseJwt = (token) => {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (e) {
      console.error('Error parsing JWT:', e);
      return {};
    }
  };

  const handleLoginSuccess = async (credentialResponse) => {
    try {
      localStorage.removeItem('is_admin');
      const response = await axios.post(
        SUPABASE_EDGE_URL,
        { credential: credentialResponse.credential },
        { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }
      );
      localStorage.setItem('auth_token', response.data.token);
      localStorage.setItem('user_email', response.data.user.email);
      if (response.data.user.lastLogin) {
        localStorage.setItem('last_login', response.data.user.lastLogin);
      }
      localStorage.setItem('is_admin', 'false');
      setToken(response.data.token);
      setUser(response.data.user);
      setError('');
      navigate('/home');
    } catch (error) {
      let errorMessage = 'An unexpected error occurred during login.';
      if (error.response) {
        const serverError = error.response.data.error;
        if (serverError?.includes('Access denied')) {
          errorMessage = 'Authentication failed: Only allowed email addresses can sign in.';
        } else if (serverError?.includes('Invalid Google credential')) {
          errorMessage = 'Google authentication failed. Please try again.';
        } else if (serverError?.includes('Database error')) {
          errorMessage = 'Server database error. Please try again later.';
        } else {
          errorMessage = serverError || 'Unknown server error';
        }
      } else if (error.request) {
        errorMessage = `Unable to reach ${SUPABASE_EDGE_URL}. Check your internet and try again.`;
      } else {
        errorMessage = `Login setup error: ${error.message}`;
      }
      setError(errorMessage);
    }
  };

  const handleLoginError = (error) => {
    setError('Google Sign-In failed. Please try again.');
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-info">
          <img src={logo} alt="VaidhyaMegha Logo" className="logo" />
          <div className="heading-group">
            <h1 className="welcome-text">Welcome to</h1>
            <h1 className="brand-text">DevOps Buddy</h1>
          </div>
          <p>Your all-in-one dashboard to monitor, automate, and manage DevOps operations — securely and smartly.</p>
        </div>
        <div className="login-form-container">
          <h2>Sign in with <strong>Google</strong></h2>
          <GoogleLogin
            onSuccess={handleLoginSuccess}
            onError={handleLoginError}
            useOneTap
            theme="outline"
            size="large"
            width="300px"
          />
          {error && (
            <p style={{ color: 'red', marginTop: '20px', whiteSpace: 'pre-wrap' }}>
              {error}
            </p>
          )}
        </div>
      </div>
      <Footer onLoginPage={true} />
    </div>
  );
}

export default Login;
